export const truncateHtml = (
  html: string,
  maxChars: number
): { html: string; wasTruncated: boolean } => {
  if (!html) {
    return { html: '', wasTruncated: false };
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const body = doc.body;

  let count = 0;
  let wasTruncated = false;
  const walker = doc.createTreeWalker(body, NodeFilter.SHOW_TEXT);

  let node = walker.nextNode() as Text | null;
  while (node) {
    const text = node.textContent ?? '';
    if (count + text.length > maxChars) {
      node.textContent = text.slice(0, maxChars - count) + '....';
      const range = doc.createRange();
      range.setStartAfter(node);
      range.setEndAfter(body.lastChild!);
      range.deleteContents();
      wasTruncated = true;
      break;
    }
    count += text.length;
    node = walker.nextNode() as Text | null;
  }

  return {
    wasTruncated,
    html: body.innerHTML
      .replace(/<p>\s*<\/p>/g, '')
      .replace(/<\/p>\s*<p>/g, ' '),
  };
};
